import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const SECTIONS = [
  'common',
  'errors',
  'auth',
  'account',
  'cart',
  'catalog',
  'checkout',
  'product-detail',
  'wishlist',
  'header',
  'footer',
];

export function useCopy() {
  const { t: i18nT, i18n } = useTranslation();

  return useCallback(
    (key, fallback) => {
      const defaultValue = fallback ?? key;
      const candidates = [key, ...SECTIONS.map((section) => `${section}.${key}`)];
      const languages =
        Array.isArray(i18n.languages) && i18n.languages.length
          ? i18n.languages
          : [i18n.resolvedLanguage || i18n.language || 'en'];

      for (const candidate of candidates) {
        for (const language of languages) {
          const raw = i18n.getResource(language, 'translation', candidate);
          if (typeof raw === 'string') {
            return i18nT(candidate, { defaultValue });
          }
        }
      }

      return defaultValue;
    },
    [i18n, i18nT],
  );
}
